<template>
    <div>
        <!-- k会员 -->
        <div class="box">
            <div class="membershipInterfaceTitle">
                <!-- 未登录 -->
                <div :class="isVip ? 'membershipHeads membershipHead' : 'membershipHead'" @click="tologin">
                    <div class="membershipHead_a">
                        <!-- 登录的头像 -->
                        <img :src="loginData.avatar" />
                    </div>

                    <div class="membershipHead_b" @click="tologin">
                        <div class="isVip ? 'clickHead':'lgincl clickHead'" v-if="loginShow">{{ loginData.nickName
                            }}
                        </div>
                        <!-- <loginPop aloneShow="true" bind:refurbish="refurbish" v-if="!loginShow"></loginPop> -->
                        <div v-if="!loginShow">立即登录</div>
                        <div class="clickHeadTitles" v-if="loginShow">
                            <span v-if="isVip">{{ endTime }} 到期</span>
                            <span v-if="isVip == false" class="lgincls">开通会员，自由刷题吧</span>
                        </div>
                        <div class="clickHeadTitle" v-if="loginShow == false">登录后查看K会员特权</div>
                    </div>
                </div>
                <div class="vipimg" v-if="isVip">
                    <img src="https://yingedu-deep-agent.ksbao.com/practicenurse/jxy1.png" class="vipimg_b">
                    <img src="https://yingedu-deep-agent.ksbao.com/practicenurse/khy1.png" class="vipimg_a">
                </div>

            </div>
            <div class="memberContent ">
                <div class="subjects_a"></div>
                <div class="subjects" @click="tologin(1)">
                    <div>
                        <div class="subjects1">开通过科目</div>
                        <div :class="loginShow ? 'subjects1' : 'subjects2'">请登录后选择科目</div>
                    </div>
                    <div>
                        <van-icon name="arrow" />
                    </div>
                </div>
                <div class="dredgeVipBox">
                    <div :class="item.id == id ? 'clinckDredgeVipCurrency dredgeVip' : 'dredgeVip'"
                        v-for="(item, index) in dredgeVipData" :key="index" @click="clickDredgeVip(item.id, item)">
                        <div class="dredgeVipTime">{{ item.coin }}{{ item.timeType }}</div>
                        <div :class="item.id == id ? 'vipColor dredgeVipCurrency' : 'dredgeVipCurrency'">
                            ¥<span :class="item.id == id ? 'vipColor textColor' : 'textColor'">{{
                                item.showPrice }}</span>
                        </div>
                        <div v-if="item.showDiscountPrice" class="sdPrice">
                            ¥{{ item.price }}
                        </div>
                        <div class="newUsers" v-if="item.top_label != null">{{ item.top_label }}</div>
                        <div class="newUsersBottom" v-if="item.dow_label != null">{{ item.dow_label }}</div>
                    </div>
                </div>
                <div class="remarks" v-if="item.remark">新用户专享档位，每个账号每个科目仅能体验 1 次</div>
                <div class="remarks remarks_a" v-if="!item.remark">1</div>
                <div class="whetherOpen" @click="whetherOpenClick">
                    {{ whetherOpen }} <span>¥{{ item.showPrice }}</span>
                </div>

                <div class="vipAgreement">购买前请仔细阅读 <span>《K会员服务协议》</span> ，点击购买后即视为您已同意该协议。</div>

                <div class="instructions">

                </div>
                <div class="instructionsPrivilege">K会员特权</div>
                <!-- 会员内容 -->
                <div class="instructionsContent">
                    <div class="instructionsContentList" v-for="(item, index) in instructionsContentListData"
                        :key="index" catchtap="tomembershipPrivilege">
                        <img :src="item.url" class="instructionsContentListImg">
                        <div class="instructionsContentListTitle_a">{{ item.name }}</div>
                        <div class="instructionsContentListTitle_b">{{ item.remark }}</div>
                    </div>
                </div>
                <div class="assistance">
                    <div class="assistanceTitle">
                        <div class="assistanceTitle_a">常见问题与帮助</div>
                        <div class="assistanceTitle_b" catchtap="tohelpCenter">更多
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <div class="assistanceTitle" v-for="(item, index) in assistanceTitleData" :key="index"
                        catchtap="tostudyReportList">
                        <div class="assistanceTitle_c">{{ item.title }}</div>
                        <div class="assistanceTitle_d">
                            <van-icon name="arrow" />
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
import {
    getVipPrice,
    virtualCoinPay,
    paymentFAQs,
    getVipInfo,
    getVipMenus,
    rechargeWxMiniProgram,
    login
} from "../api/api";
export default {
    data() {
        return {
            dredgeVipData: [], //金币卡片
            whetherOpen: "确认协议并支付", //开通按钮
            instructionsContentListData: [],
            assistanceTitleData: [{
                title: "开通会员后，所有科目都通用吗？"
            },
            {
                title: "购买会员服务后可以退款吗？"
            },
            {
                title: "能不能使用微信支付/支付宝支付？"
            },
            {
                title: "怎么充值考拉币？"
            },
            ],
            isVip: false, //判断是否开通会员
            loginShow: false, //判断是否登录
            successfullysOpened: false, //显示弹窗
            SuccessfullyOpened: false, //成功开通
            InsufficientGoldCoins: false, //金币不足
            WhetherOpen: false, //是否开通
            id: "1", //购买的id
            item: "",
            platform: "",
            loginData: []
        }
    },
    created() {
        let max = 9999;
        let min = 1234;
        let num = Math.floor(Math.random() * (max - min)) + min
        var data = {
            type: 1,
            source: "H5",
            soleCode: num
        }
        login(data).then(res => {
            res.data.data.userName = ""
            res.data.data.appCName = "护士执业 "
            res.data.data.appEName = "ZY_HS_YTMJ"
            res.data.data.appID = 1951;
            localStorage.setItem('loginData', JSON.stringify(res.data.data));
            this.refurbish();
        })

    },
    mounted() {

    },
    methods: {
        //没登录点击头像登录
        tologin(index) {
            if (this.loginShow == false) {
                this.$router.push({ path: '/login' })
                return
            }
        },
        //会员判断
        refurbish() {
            var loginData = JSON.parse(localStorage.getItem('loginData'))
            if (loginData.userName.length > 0) {
                this.loginShow = true;
                this.isVip = loginData.isVip;
                this.loginData = loginData;
            } else {
                this.loginData = loginData;
            }
            var data = {
                appEName: loginData.appEName,
                guid: loginData.guid,
                userID: loginData.userID,
            }
            getVipPrice(data).then(res => {
                this.dredgeVipData = res.data.data;
                this.item = res.data.data[0];
            })
            paymentFAQs(data).then(res => {
                this.assistanceTitleData = res.data.data;
            })
            getVipInfo(data).then(res => {
                if (res.data.data.endTime) {
                    this.whetherOpen = "立即续费";
                    this.loginData = loginData;
                }
            })
            getVipMenus(data).then(res => {
                this.instructionsContentListData = res.data.data;
            })

        },
        //点击选中当前的虚拟币购买
        clickDredgeVip(id, item) {
            this.id = id;
            this.item = item;
        },
        // 点击立即开通
        whetherOpenClick() {
            if (this.data.loginShow == false) {
                this.$router.push({ path: '/login' })
                return
            }
            if (this.data.id.length == 0) {
                wx.showToast({
                    title: "请选择上方开通会员时长",
                    icon: 'none',
                })
                return
            }
            this.priceClick();
        },
        //点击价格充值
        priceClick() {

            var data = {
                rechargePriceId: this.data.id,
                payMode: 'HTML5'
            }
            const ua = window.navigator.userAgent.toLowerCase();
            // return ua.match(/micromessenger/i) == "micromessenger";
            if (ua.match(/micromessenger/i) == "micromessenger") {
                payType = "wechat";
            }
            var that = this;
            rechargeWxMiniProgram(data, (res) => {
                var datas = res.data.data.wxminipay;
                if (res.statusCode == 200) {
                    wx.requestPayment({ // 这一步是调起微信支付
                        "appId": datas.appId,
                        "timeStamp": datas.timeStamp + "",
                        "nonceStr": datas.nonceStr,
                        "package": datas.package,
                        "signType": datas.signType,
                        "paySign": datas.paySign,
                        "success": function (res) {
                            that.setData({
                                successfullysOpened: true,
                                SuccessfullyOpened: true
                            })
                            wx.hideLoading({})
                            that.getVipInfoRenovate();
                            getVipPrice({}, (res) => {
                                that.setData({
                                    dredgeVipData: res.data.data,
                                    item: res.data.data[0]
                                })
                            })
                            console.log("我是购买返回1", res)
                        },
                        "fail": function (res) {
                            console.log("我是购买返回2", res)
                        },
                        "complete": function (res) {
                            console.log("我是购买返回3", res)
                        }
                    })
                } else {
                    wx.hideLoading({})
                }
            })
        },
    },
}
</script>
<style scoped>
.subjects {
    height: 46px;
    border-radius: 10px;
    background: #FFFDF0;
    margin: 0 20px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.subjects1 {
    color: #1A1A1A;
    font-size: 12px;
    padding-bottom: 5px;
}

.subjects2 {
    color: #999;
    font-size: 17px;
}

.subjects_a {
    height: 20px;
}

.box {
    height: 100vh;
    background-color: #202024;
    overflow-y: auto;
    font-family: MiSans;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
}

.membershipInterfaceTitle {
    height: 158px;
    background: url('https://yingedu-deep-agent.ksbao.com/practicenurse/khy10.png');
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
    position: relative;
}

.vipAgreement {
    padding: 20px;
    color: #999999;
    font-size: 12px;
}

.vipAgreement text {
    color: #F5A300
}

.membershipHead {
    height: 109px;
    background: #EFF5FF;
    border-radius: 16px 16px 0px 0px;
    border: 1px solid #4366A0;
    margin: 0 16px;
    width: 343px;
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
}

.membershipHeads {
    background: url('https://yingedu-deep-agent.ksbao.com/practicenurse/khy9.png');
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
}

.membershipHead_a {
    width: 62px;
    height: 62px;
    margin: 0 15px;
    border: 3px solid rgba(255, 255, 255, 0.4);
    border-radius: 50px;
}

.membershipHead_a img {
    width: 100%;
    height: 100%;
    border-radius: 50px;
    border: 3px solid rgba(255, 255, 255, 0.4);
}

.clickHead {

    font-weight: 500;
    color: #333333;
}

.clickHeadTitle {
    /* padding-top: 8px; */
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
}

.clickHeadTitles {
    padding-top: 8px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #351E00;
}

.memberContent {
    background: #FFFFFF;
    border-radius: 16px 16px 0px 0px;
    height: 1300px;
}

.dredgeVipBox {
    display: flex;
    flex-wrap: wrap;
    margin-left: 16px;
    padding-top: 15px;
    padding-bottom: 10px;
}

.dredgeVip {
    width: 106px;
    height: 124px;
    background: #FFFEF9;
    border-radius: 12px;
    border: 1px solid #FFEECB;
    margin-right: 10px;
    text-align: center;
    margin-top: 10px;
    position: relative;
}

.dredgeVipTime {
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-top: 26px;
}

.dredgeVipCurrency {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    padding-top: 0px;
}

.textColor {
    font-size: 26px;
    font-family: HarmonyOS_Sans_Bold;
    color: #333333;
}

.clinckDredgeVipCurrency {
    background: #FFFDF0;
    border-radius: 12px;
    border: 1px solid #F5A300;
}

.vipColor {
    color: #F5A300;
}

.whetherOpen {
    width: 343px;
    height: 48px;
    background: #FFDB00;
    border-radius: 24px;
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;
    line-height: 48px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
}

.whetherOpens {
    background-color: #fff;
    border: 1px solid #333333;
}

.instructions {
    padding: 16px 16px 15px 16px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
}

.instructions text {
    color: #F5A300;
}

.instructionsPrivilege {
    padding: 0 16px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
}

.instructionsContent {
    display: flex;
    flex-wrap: wrap;
}

.instructionsContentList {
    width: 125px;
    text-align: center;
    padding-bottom: 20px;
}

.instructionsContentListImg {
    width: 40px;
    height: 40px;
}

.instructionsContentListTitle_a {
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
}

.instructionsContentListTitle_b {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    padding-top: 4px;
}

.assistance {
    padding: 0 16px;
    padding-top: 20px;
}

.assistanceTitle {
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
}

.assistanceTitle_a {
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
}

.assistanceTitle_b {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
}

.assistanceTitle_c {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.assistanceTitle_d {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
}

.vipimg {
    display: flex;
    position: absolute;
    bottom: 76px;
    right: 28px;
}

.vipimg_a {
    width: 56px;
    height: 14px;
    padding-top: 4px;
    padding-left: 3px;
}

.vipimg_b {
    width: 20px;
    height: 20px;
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.block {
    width: 300px;
    height: 240px;
    background: linear-gradient(180deg, #FFF4CF 0%, #FFFFFF 100%);
    border: 4px solid #FFCE68;
    border-radius: 12px;
    margin: 0 auto;
    text-align: center;
}

.blockImg {
    width: 58px;
    height: 58px;
    padding-top: 40px;
}

.blocktitle {
    padding: 16px 0 27px 0;
}

.blockConfirm {
    width: 243px;
    height: 44px;
    background: #FFDB00;
    border-radius: 24px;
    margin: 0 auto;
    line-height: 44px;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.deficiency {
    display: flex;
    justify-items: center;

}

.abjuration {
    width: 116px;
    height: 44px;
    background: #F5F7FB;
    border-radius: 22px;
    text-align: center;
    line-height: 44px;
    margin-left: 25px;
    margin-right: 11px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;
}

.deficiencyConfirm {
    width: 116px;
    height: 44px;
    background: #FFDB00;
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 44px;
}

.lgincl {
    color: #266D8E;
}

.lgincls {
    color: #6399BB;
}

.newUsers {
    width: 60px;
    height: 17px;
    border-radius: 10px 10px 10px 0px;
    padding: 7px 10px;
    position: absolute;
    top: -10px;
    left: -1px;
    background: linear-gradient(69deg, #FA9044 0%, #FC5A45 39%, #FC5A45 67%, #FE4EBB 100%);
    /* filter: blur(20px); */
    box-shadow: inset 0px 1px 0px 0px #EEEEEE;
    color: #FFFFFF;
    font-size: 12px;
}

.newUsersBottom {
    position: absolute;
    left: 0px;
    bottom: 0;
    width: 100%;
    height: 22px;
    border-radius: 0px 0px 12px 12px;
    opacity: 1;
    background: #FFEECB;
    font-size: 12px;
    line-height: 22px;
    color: #E17000;
}

.sdPrice {
    font-size: 10px;
    color: #AAAAAA;
    text-decoration: line-through;
}

.remarks {
    font-size: 12px;
    text-align: center;
    color: #999999;
}

.remarks_a {
    color: #ffffff;
}
</style>